import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { i18n } from '../../../../../symphony';
import { LocalizedLink } from '../../../../../shared/public/LocalizedLink/LocalizedLink';
import { ILPBlogData, IBlogCard } from '../../../../../api/private/learn-engine-api/landing-page-api.interface';

import s from './BlogSection.scss';

interface IBlogSectionProps {
	data: ILPBlogData;
	alias: string;
}

export function BlogSection({ data, alias }: IBlogSectionProps): JSX.Element {
	useStyles(s);
	const { blogItems } = data;

	return (
		<section className="lp-blog-section">
			<div className="lp-blog-section__container">
				<h3 className="lp-blog-section__title">
					{i18n.t(`web-lelp.${alias}-blog-section-title`)}
				</h3>
				<div className="lp-blog-section__blogs-box">
					{blogItems.map(({ id, imgUrl }: IBlogCard, index) => (
						<article
							className="lp-blog-section__blog-card"
							key={id}
						>
							<LocalizedLink
								to={`/blog/${id}`}
								className="lp-blog-section__card-image"
								target="_blank"
							>
								<img src={imgUrl} alt="blog" />
							</LocalizedLink>
							<div className="lp-blog-section__card-content">
								<div className="lp-blog-section__card-text-wrapper">
									<div className="lp-blog-section__card-title">
										{i18n.t(
											`web-lelp.${alias}-blog-section-item${index}-title`,
										)}
									</div>
									<div className="lp-blog-section__card-text">
										{i18n.t(
											`web-lelp.${alias}-blog-section-item${index}-description`,
										)}
									</div>
								</div>
								<LocalizedLink
									to={`/blog/${id}`}
									className="lp-blog-section__card-link"
									target="_blank"
								>
									{i18n.t(
										`web-lelp.${alias}-blog-section-item${index}-link`,
									)}
								</LocalizedLink>
							</div>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
